import EditableText from './EditableText';
import { Section } from './types';
import { Sections } from '../wizard/types';
import { ReportData } from './types';
import { SECTIONS } from '../wizard/constants';
import { AIBadge } from '@/components/ui/ai-badge';
import { isBuiltInReportSectionId } from '@/lib/report-sections';

interface SectionTitleProps {
    section: Section;
    data: ReportData;
    onUpdate: (updates: Partial<ReportData> | ((prev: ReportData) => Partial<ReportData>)) => void;
    disabled?: boolean;
}

export default function SectionTitle({ section, data, onUpdate, disabled }: SectionTitleProps) {
    const primaryColor = data?.customizations?.colors?.primary;

    const hasAutoTests =
        section.id === SECTIONS.TESTS &&
        (data.tests?.blocks || []).some(
            (block) => 'automatic' in block && Boolean(block.automatic),
        );

    return (
        <>
            <div className="relative mb-2 flex items-center justify-between gap-3 group">
                <h2 className="text-lg font-bold text-slate-700 flex-grow flex items-center gap-2">
                    <span style={{ color: primaryColor }}>{section.number}.</span>{' '}
                    <EditableText
                        value={section.title}
                        onSave={(value) => {
                            onUpdate((prevData) => {
                                if (!isBuiltInReportSectionId(section.id)) {
                                    return {
                                        custom_sections: (prevData.custom_sections ?? []).map(
                                            (customSection) =>
                                                customSection.id === section.id
                                                    ? {
                                                          ...customSection,
                                                          section_title: value,
                                                      }
                                                    : customSection,
                                        ),
                                    };
                                }

                                const currentData = prevData[section.id as Sections];
                                const newData =
                                    typeof currentData === 'object' && currentData !== null
                                        ? {
                                              ...currentData,
                                              section_title: value,
                                          }
                                        : {
                                              content: currentData,
                                              section_title: value,
                                          };
                                return { ...prevData, [section.id]: newData };
                            });
                        }}
                        placeholder="Section title..."
                        className="inline"
                        disabled={disabled}
                    />
                </h2>

                <div className="flex items-center gap-2">
                    {hasAutoTests && <AIBadge>Gerado automaticamente</AIBadge>}
                </div>
            </div>
            <hr style={{ borderColor: primaryColor }} className="my-1 mb-2 border-t-" />
        </>
    );
}
